<template>
  <div style="display: flex; margin: 5px">
    {{ $t('Order_Grade') }}:
    <SfIcon class="sf-header__icon" icon="minus" size="1.25rem" @click="jian" />
    <SfRating :score="grade1" :max="5" :min="1" v-model="grade1" />
    <SfIcon class="sf-header__icon" icon="plus" size="1.25rem" @click="jia" />
  </div>
</template>

<script>
import { ref } from '@nuxtjs/composition-api';
import { SfIcon, SfRating } from '@storefront-ui/vue';
export default {
  name: 'Reviewrating',
  components: {
    SfIcon,
    SfRating
  },
  setup(props, Content) {
    const grade1 = ref(5);
    const jia = () => {
      if (grade1.value < 5) {
        grade1.value++;
        Content.emit('jia-grade', grade1.value);
      }
    };

    const jian = () => {
      if (grade1.value === 1) {
        return false;
      }
      grade1.value--;
      Content.emit('jian-grade', grade1.value);
    };

    return {
      jia,
      jian,
      grade1
    };
  }
};
</script>
<style lang="scss" scoped>
.itemList {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.afterForm {
  width: 100%;
}
.modalShouHou {
  --modal-width: 65rem;
  --modal-left: 20%;
  --modal-transform: translate3d(-15%, -20%, 0);
  --modal-top: 10%;
}
</style>
<style lang="scss" >
.modalShouHou {
  > .sf-modal__container {
    z-index: 999999999999;
    margin-top: 20px;
  }
}
</style>
